// import styles from "./footer.module.css";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaInstagram,
// } from "react-icons/fa";
// import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";
// import { HeadingTitle, Image } from "../../shared/index";
// import { Link } from "react-router-dom";
// import { BsYoutube } from "react-icons/bs";

// const Footer = () => {
//   const productLinks = [
//     // { name: "Categories", path: "/categories" },
//     { name: "Shop", path: "/shop" },
//     { name: "About us", path: "/about" },
//     { name: "Contact", path: "/contact" },
//     // { name:"Admin Login", path:"/admin/login"} 
//   ];

//   const policyLinks = [
//     { name: "Privacy Policy", path: "/privacy-policy" },
//     { name: "Refund Policy", path: "/refund-policy" },
//     { name: "Terms and Conditions", path: "/terms-and-conditions" },
//     { name: "Shipping Policy", path: "/shipping-policy" },
//   ];

//   const socialIcons = [
//     { icon: <FaFacebookF />, label: "Facebook", url: "https://www.facebook.com/p/GDRB-Technologies-Pvt-Ltd-100088258881230/" },
//     // { icon: <FaTwitter />, label: "Twitter", url: "https://twitter.com" },
//     { icon: <FaInstagram />, label: "Instagram", url: "https://www.instagram.com/gdrbtechnologies/" },
//     { icon: <BsYoutube />, label: "YouTube", url: "https://www.youtube.com/@gdrbtechnologies" },
//   ];

//   const year = new Date().getFullYear();
//   return (
//     <footer className={styles.footer}>
//       <div className={styles.footer__wrapper}>

//         {/* LOGO + SOCIAL */}
//         <div className={styles.footerSection}>
//           <div className={styles.logoBox}>
//             <Image
//               src={"/Fashion_logo.svg"}
//               alt="Anuradha-logo"
//               className={styles.anuradha__logo}
//             />
//           </div>

//           <p className={styles.description}>
//             GDRB Technologies creates tailored
//             IT solutions , blending business insight
//             with tech expertise .
//           </p>

//           <div className={styles.socialSection}>
//             <span className={styles.socialTitle}>Follow Us On</span>
//             <div className={styles.socialIcons}>
//               {socialIcons.map((social, index) => (
//                 <a
//                   key={index}
//                   href={social.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className={styles.socialIcon}
//                   aria-label={social.label}
//                 >
//                   {social.icon}
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* PRODUCT LINKS */}
//         <div className={styles.footerSection}>
//           <HeadingTitle text="OUR STORES" style={styles.sectionTitle} />
//           <ul className={styles.linkList}>
//             {productLinks.map((item, index) => (
//               <li key={index}>
//                 <Link to={item.path} className={styles.link}>
//                   {item.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* POLICY LINKS */}
//         <div className={styles.footerSection}>
//           <HeadingTitle text="SHOP CATEGORIES" style={styles.sectionTitle} />
//           <ul className={styles.linkList}>
//             {policyLinks.map((item, index) => (
//               <li key={index}>
//                 <Link to={item.path} className={styles.link}>
//                   {item.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* CONTACT INFO */}
//         <div className={styles.footerSection}>
//           <HeadingTitle text="ABOUT US" style={styles.sectionTitle} />
//           <div className={styles.contactInfo}>
//             <div className={styles.contactItem}>
//               <MdLocationOn className={styles.contactIcon} />
//               <span className={styles.contactText}>
//                 Address -  3rd Floor, OPP: HDFC Bank,
// Plot.No.-98, Venkateshwara Enclave,
// Suchitra 'X' Road,
// Hyderabad - 500067
//               </span>
//             </div>
//             <div className={styles.contactItem}>
//               <MdPhone className={styles.contactIcon} />
//               <span className={styles.contactText}>Call Us: +91  8886060799</span>
//             </div>
//             <div className={styles.contactItem}>
//               <MdEmail className={styles.contactIcon} />
//               <span className={styles.contactText}>Email: info@gdrbtechnologies.com</span>
//             </div>
//           </div>
//         </div>

//       </div>
//       <div className={styles.footerBottom}>
//         <p>
//           Copyright © {year} GDRB Technologies Pvt Ltd. All Rights Reserved.
//         </p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import styles from "./footer.module.css";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";
import { HeadingTitle, Image } from "../../shared/index";
import { Link } from "react-router-dom";
import { BsYoutube } from "react-icons/bs";

const Footer = () => {
  const productLinks = [
    // { name: "Categories", path: "/categories" },
    { name: "Shop", path: "/shop" },
    { name: "About us", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  const policyLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Terms and Conditions", path: "/terms-and-conditions" },
    { name: "Shipping Policy", path: "/shipping-policy" },
  ];

  const socialIcons = [
    {
      icon: <FaFacebookF />,
      label: "Facebook",
      url: "https://www.facebook.com/p/GDRB-Technologies-Pvt-Ltd-100088258881230/",
    },
    {
      icon: <FaInstagram />,
      label: "Instagram",
      url: "https://www.instagram.com/gdrbtechnologies/",
    },
    {
      icon: <BsYoutube />,
      label: "YouTube",
      url: "https://www.youtube.com/@gdrbtechnologies",
    },
  ];

  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footer__wrapper}>

        {/* LOGO + SOCIAL */}
        <div className={styles.footerSection}>
          <div className={styles.logoBox}>
             <Image
              src={"/Fashion_logo.svg"}
              alt="GDRB Fashion-logo"
              className={styles.anuradha__logo}
            />
          </div>

          <p className={styles.description}>
            GDRB Technologies creates tailored IT solutions,
            blending business insight with tech expertise.
          </p>

        
<div className={styles.socialSection}>
  <span className={styles.socialTitle}>Follow Us On</span>

  <div className={styles.socialIcons}>
    {socialIcons.map((social, index) => (
      <a
        key={index}
        href={social.url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.socialIcon}
        aria-label={social.label}
      >
        {social.icon}
      </a>
    ))}
  </div>
</div>
        </div>

        {/* OUR STORES */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="OUR STORES"
            style={styles.sectionTitle}
          />

          <ul className={styles.linkList}>
            {productLinks.map((item, index) => (
              <li key={index}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* SHOP CATEGORIES */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="SHOP CATEGORIES"
            style={styles.sectionTitle}
          />

          <ul className={styles.linkList}>
            {policyLinks.map((item, index) => (
              <li key={index}>
                <Link to={item.path} className={styles.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* ABOUT US */}
        <div className={styles.footerSection}>
          <HeadingTitle
            text="ABOUT US"
            style={styles.sectionTitle}
          />

          <div className={styles.contactInfo}>

            <div className={styles.contactItem}>
              <MdLocationOn className={styles.contactIcon} />

              <span className={styles.contactText} style={{color:"white"}}>
                Address - 3rd Floor, OPP: HDFC Bank,
                Plot.No.-98, Venkateshwara Enclave,
                Suchitra 'X' Road,
                Hyderabad - 500067
              </span>
            </div>

            <div className={styles.contactItem}>
              <MdPhone className={styles.contactIcon} />
  <a style={{color:"white"}}
    href="tel:+918886060799"
    className={styles.contactText}
  >
     +91 8886060799
  </a>
              {/* <span className={styles.contactText}>
                Call Us: +91 8886060799
              </span> */}
            </div>

            <div className={styles.contactItem}>
              <MdEmail className={styles.contactIcon} />

              {/* <span className={styles.contactText}>
                Email: info@gdrbtechnologies.com
              </span> */}
             <a style={{color:"white"}}
      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gdrbtechnologies.com"
      target="_blank"
      rel="noopener noreferrer"
    >
   info@gdrbtechnologies.com 
    </a>    </div>

          </div>
        </div>

      </div>

      {/* COPYRIGHT */}
      <div className={styles.footerBottom}>
        <p>
          Copyright © {year} GDRB Technologies Pvt Ltd. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;